import SearchIcon from "rivals/components/shared/Icons/SearchIcon";
import styles from "./EmptyTableResult.module.scss";
import strings from "./strings";
import { OwnProps } from "./types";

const EmptyTableResult = ({ emptyText }: OwnProps): JSX.Element => (
  <div className={styles.noResultsWrapper}>
    <SearchIcon fill={styles["gray95"]} />
    <div className={styles.mainMessage}>{strings.noResults}</div>
    <div className={styles.descMessage}>{emptyText}</div>
  </div>
);

export default EmptyTableResult;
